import { ReportData } from '../types/reportTypes';

export const SAMPLE_REPORT_DATA: Record<string, ReportData> = {
  gi_comp_112: {
    test_id: "GI_159809",
    panel_type: "GI_COMPREHENSIVE",
    panel_size: 112,
    patient_info: {
      patient_id: "56012",
      patient_name: "Johnson, Maria",
      patient_dob: "1988-03-15",
      patient_gender: "Female",
      patient_age: "36 years"
    },
    collection_info: {
      collection_site: "RECTAL",
      specimen_type: "Fecal Swab",
      collection_date: "2024-01-15T14:30:00-06:00",
      received_date: "2024-01-16T09:15:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Sarah Chen",
      provider_location: "Gastroenterology Clinic"
    },
    test_details: {
      bacteria: [
        { name: "Clostridium difficile", result: "Detected" },
        { name: "Salmonella spp.", result: "Not Detected" },
        { name: "Shigella spp.", result: "Not Detected" },
        { name: "Campylobacter jejuni", result: "Not Detected" }
      ],
      viruses: [
        { name: "Norovirus GI/GII", result: "Not Detected" },
        { name: "Rotavirus", result: "Not Detected" }
      ],
      fungi: [
        { name: "Candida albicans", result: "Not Detected" }
      ],
      resistance_genes: [
        { name: "vanA", result: "Not Detected" },
        { name: "vanB", result: "Not Detected" }
      ],
      parasites: [
        { name: "Giardia lamblia", result: "Not Detected" },
        { name: "Cryptosporidium spp.", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [{ name: "Clostridium difficile", result: "Detected" }],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Clostridium difficile",
          standardized_name: "clostridium difficile",
          category: "bacteria",
          weight: 45.8,
          priority_rank: 1
        }
      ],
      treatment: {
        primary: {
          drug_name: "Vancomycin",
          dosage: "125 mg",
          route: "PO",
          frequency: "q6h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Fidaxomicin", dosage: "200 mg", route: "PO", frequency: "q12h" },
            { name: "Metronidazole", dosage: "500 mg", route: "PO", frequency: "q8h" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for clinical response",
            "Assess for recurrence",
            "Monitor for complications"
          ]
        }
      }
    }
  },

  uti_ud_112: {
    test_id: "UTI_159810",
    panel_type: "UTI_URINE_DETECTION",
    panel_size: 112,
    patient_info: {
      patient_id: "56013",
      patient_name: "Thompson, Robert",
      patient_dob: "1975-07-22",
      patient_gender: "Male",
      patient_age: "49 years"
    },
    collection_info: {
      collection_site: "URINE",
      specimen_type: "Urine Swab",
      collection_date: "2024-01-16T10:45:00-06:00",
      received_date: "2024-01-16T16:20:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Michael Rodriguez",
      provider_location: "Urology Department"
    },
    test_details: {
      bacteria: [
        { name: "Escherichia coli", result: "Detected" },
        { name: "Klebsiella pneumoniae", result: "Not Detected" },
        { name: "Enterococcus faecalis", result: "Not Detected" },
        { name: "Pseudomonas aeruginosa", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [
        { name: "Candida albicans", result: "Not Detected" }
      ],
      resistance_genes: [
        { name: "CTX-M (ESBL)", result: "Detected" },
        { name: "KPC", result: "Not Detected" },
        { name: "NDM", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [{ name: "Escherichia coli", result: "Detected" }],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Escherichia coli",
          standardized_name: "escherichia coli",
          category: "bacteria",
          weight: 36.12,
          priority_rank: 1
        }
      ],
      treatment: {
        primary: {
          drug_name: "Meropenem",
          dosage: "1-2 gm",
          route: "IV",
          frequency: "q8h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Ertapenem", dosage: "1 gm", route: "IV/IM", frequency: "q24h" },
            { name: "Imipenem-Cilastatin", dosage: "500 mg", route: "IV", frequency: "q6h" },
            { name: "Fosfomycin", dosage: "3 gm", route: "PO", frequency: "single dose" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for clinical response",
            "Assess for adverse drug reactions",
            "Monitor for GI effects",
            "Monitor for hypersensitivity"
          ]
        }
      }
    }
  },

  rpp_sinus_112: {
    test_id: "RPP_159811",
    panel_type: "RESPIRATORY_PATHOGEN_PANEL",
    panel_size: 112,
    patient_info: {
      patient_id: "56014",
      patient_name: "Williams, Jennifer",
      patient_dob: "1992-11-08",
      patient_gender: "Female",
      patient_age: "32 years"
    },
    collection_info: {
      collection_site: "NASAL",
      specimen_type: "Nasal Swab",
      collection_date: "2024-01-17T11:20:00-06:00",
      received_date: "2024-01-17T18:45:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Lisa Park",
      provider_location: "ENT Department"
    },
    test_details: {
      bacteria: [
        { name: "Streptococcus pneumoniae", result: "Detected" },
        { name: "Haemophilus influenzae", result: "Not Detected" },
        { name: "Moraxella catarrhalis", result: "Not Detected" },
        { name: "Staphylococcus aureus", result: "Not Detected" }
      ],
      viruses: [
        { name: "Rhinovirus", result: "Not Detected" },
        { name: "Influenza A", result: "Not Detected" },
        { name: "RSV", result: "Not Detected" }
      ],
      fungi: [
        { name: "Aspergillus fumigatus", result: "Not Detected" }
      ],
      resistance_genes: [
        { name: "mecA", result: "Not Detected" },
        { name: "vanA", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [{ name: "Streptococcus pneumoniae", result: "Detected" }],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Streptococcus pneumoniae",
          standardized_name: "streptococcus pneumoniae",
          category: "bacteria",
          weight: 42.3,
          priority_rank: 1
        }
      ],
      treatment: {
        primary: {
          drug_name: "Amoxicillin-Clavulanate",
          dosage: "875/125 mg",
          route: "PO",
          frequency: "q12h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Azithromycin", dosage: "500 mg", route: "PO", frequency: "daily" },
            { name: "Ceftriaxone", dosage: "1-2 gm", route: "IV", frequency: "q24h" },
            { name: "Levofloxacin", dosage: "750 mg", route: "PO", frequency: "daily" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for clinical response",
            "Assess for allergic reactions",
            "Monitor for GI tolerance"
          ]
        }
      }
    }
  },

  wnd_acute_56: {
    test_id: "WND_159812",
    panel_type: "WOUND_ACUTE",
    panel_size: 56,
    patient_info: {
      patient_id: "56015",
      patient_name: "Davis, Michael",
      patient_dob: "1980-05-12",
      patient_gender: "Male",
      patient_age: "44 years"
    },
    collection_info: {
      collection_site: "WOUND",
      specimen_type: "Wound Swab",
      collection_date: "2024-01-18T09:30:00-06:00",
      received_date: "2024-01-18T15:10:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Amanda Foster",
      provider_location: "Emergency Department"
    },
    test_details: {
      bacteria: [
        { name: "Staphylococcus aureus", result: "Detected" },
        { name: "Streptococcus pyogenes", result: "Not Detected" },
        { name: "Pseudomonas aeruginosa", result: "Not Detected" },
        { name: "Enterococcus faecalis", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [
        { name: "Candida albicans", result: "Not Detected" }
      ],
      resistance_genes: [
        { name: "mecA (MRSA)", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [{ name: "Staphylococcus aureus", result: "Detected" }],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Staphylococcus aureus",
          standardized_name: "staphylococcus aureus",
          category: "bacteria",
          weight: 38.7,
          priority_rank: 1
        }
      ],
      treatment: {
        primary: {
          drug_name: "Cephalexin",
          dosage: "500 mg",
          route: "PO",
          frequency: "q6h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Clindamycin", dosage: "300 mg", route: "PO", frequency: "q6h" },
            { name: "Doxycycline", dosage: "100 mg", route: "PO", frequency: "q12h" },
            { name: "Trimethoprim-Sulfamethoxazole", dosage: "160/800 mg", route: "PO", frequency: "q12h" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor wound healing",
            "Assess for clinical response",
            "Monitor for allergic reactions"
          ]
        }
      }
    }
  },

  wnd_comp_112: {
    test_id: "WND_159813",
    panel_type: "WOUND_COMPREHENSIVE",
    panel_size: 112,
    patient_info: {
      patient_id: "56016",
      patient_name: "Anderson, Patricia",
      patient_dob: "1965-09-03",
      patient_gender: "Female",
      patient_age: "59 years"
    },
    collection_info: {
      collection_site: "WOUND",
      specimen_type: "Wound Swab",
      collection_date: "2024-01-19T13:15:00-06:00",
      received_date: "2024-01-19T20:30:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. James Wilson",
      provider_location: "Wound Care Center"
    },
    test_details: {
      bacteria: [
        { name: "Pseudomonas aeruginosa", result: "Detected" },
        { name: "Acinetobacter baumannii", result: "Detected" },
        { name: "Staphylococcus aureus", result: "Not Detected" },
        { name: "Enterococcus faecium", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [
        { name: "Candida albicans", result: "Detected" }
      ],
      resistance_genes: [
        { name: "blaOXA-23", result: "Detected" },
        { name: "blaKPC", result: "Not Detected" },
        { name: "blaNDM", result: "Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [
            { name: "Pseudomonas aeruginosa", result: "Detected" },
            { name: "Acinetobacter baumannii", result: "Detected" }
          ],
          viruses: [],
          fungi: [{ name: "Candida albicans", result: "Detected" }],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Pseudomonas aeruginosa",
          standardized_name: "pseudomonas aeruginosa",
          category: "bacteria",
          weight: 52.1,
          priority_rank: 1
        },
        {
          name: "Acinetobacter baumannii",
          standardized_name: "acinetobacter baumannii",
          category: "bacteria",
          weight: 48.9,
          priority_rank: 2
        }
      ],
      treatment: {
        primary: {
          drug_name: "Meropenem + Colistin",
          dosage: "2 gm + 5 mg/kg",
          route: "IV",
          frequency: "q8h + q12h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Ceftazidime-Avibactam", dosage: "2.5 gm", route: "IV", frequency: "q8h" },
            { name: "Polymyxin B", dosage: "2.5-3 mg/kg", route: "IV", frequency: "q12h" },
            { name: "Tigecycline", dosage: "100 mg", route: "IV", frequency: "q12h" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for nephrotoxicity",
            "Assess wound healing progression",
            "Monitor for drug resistance development",
            "Regular culture surveillance"
          ]
        }
      }
    }
  },

  wnd_comp_abx_112: {
    test_id: "WND_159814",
    panel_type: "WOUND_COMPREHENSIVE_ABX",
    panel_size: 112,
    patient_info: {
      patient_id: "56017",
      patient_name: "Garcia, Carlos",
      patient_dob: "1970-12-18",
      patient_gender: "Male",
      patient_age: "54 years"
    },
    collection_info: {
      collection_site: "WOUND",
      specimen_type: "Wound Swab",
      collection_date: "2024-01-20T08:45:00-06:00",
      received_date: "2024-01-20T14:15:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Emily Zhang",
      provider_location: "Infectious Disease Clinic"
    },
    test_details: {
      bacteria: [
        { name: "Enterococcus faecium", result: "Detected" },
        { name: "Klebsiella pneumoniae", result: "Detected" },
        { name: "Staphylococcus epidermidis", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [],
      resistance_genes: [
        { name: "vanA", result: "Detected" },
        { name: "blaKPC", result: "Detected" },
        { name: "blaCTX-M", result: "Detected" },
        { name: "mecA", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [
            { name: "Enterococcus faecium", result: "Detected" },
            { name: "Klebsiella pneumoniae", result: "Detected" }
          ],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Enterococcus faecium",
          standardized_name: "enterococcus faecium",
          category: "bacteria",
          weight: 58.4,
          priority_rank: 1
        },
        {
          name: "Klebsiella pneumoniae",
          standardized_name: "klebsiella pneumoniae",
          category: "bacteria",
          weight: 54.2,
          priority_rank: 2
        }
      ],
      treatment: {
        primary: {
          drug_name: "Linezolid + Meropenem-Vaborbactam",
          dosage: "600 mg + 4 gm",
          route: "IV",
          frequency: "q12h + q8h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Daptomycin + Ceftazidime-Avibactam", dosage: "10 mg/kg + 2.5 gm", route: "IV", frequency: "q24h + q8h" },
            { name: "Tigecycline + Colistin", dosage: "100 mg + 5 mg/kg", route: "IV", frequency: "q12h + q12h" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for VRE resistance development",
            "Assess for nephrotoxicity",
            "Monitor wound healing",
            "Regular antimicrobial stewardship review",
            "Monitor for drug interactions"
          ]
        }
      }
    }
  },

  wnd_comp_56: {
    test_id: "WND_159815",
    panel_type: "WOUND_COMPREHENSIVE",
    panel_size: 56,
    patient_info: {
      patient_id: "56018",
      patient_name: "Brown, Ashley",
      patient_dob: "1985-02-28",
      patient_gender: "Female",
      patient_age: "39 years"
    },
    collection_info: {
      collection_site: "WOUND",
      specimen_type: "Wound Swab",
      collection_date: "2024-01-21T12:00:00-06:00",
      received_date: "2024-01-21T17:30:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Kevin Lee",
      provider_location: "Dermatology Clinic"
    },
    test_details: {
      bacteria: [
        { name: "Staphylococcus aureus", result: "Detected" },
        { name: "Streptococcus pyogenes", result: "Detected" },
        { name: "Enterococcus faecalis", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [],
      resistance_genes: [
        { name: "mecA", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [
            { name: "Staphylococcus aureus", result: "Detected" },
            { name: "Streptococcus pyogenes", result: "Detected" }
          ],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Staphylococcus aureus",
          standardized_name: "staphylococcus aureus",
          category: "bacteria",
          weight: 40.5,
          priority_rank: 1
        },
        {
          name: "Streptococcus pyogenes",
          standardized_name: "streptococcus pyogenes",
          category: "bacteria",
          weight: 35.2,
          priority_rank: 2
        }
      ],
      treatment: {
        primary: {
          drug_name: "Clindamycin",
          dosage: "300 mg",
          route: "PO",
          frequency: "q6h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Cephalexin", dosage: "500 mg", route: "PO", frequency: "q6h" },
            { name: "Azithromycin", dosage: "500 mg", route: "PO", frequency: "daily" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor wound healing",
            "Assess for clinical response",
            "Monitor for GI tolerance"
          ]
        }
      }
    }
  },

  wnd_comp_abx_56: {
    test_id: "WND_159816",
    panel_type: "WOUND_COMPREHENSIVE_ABX",
    panel_size: 56,
    patient_info: {
      patient_id: "56019",
      patient_name: "Miller, Steven",
      patient_dob: "1978-08-14",
      patient_gender: "Male",
      patient_age: "46 years"
    },
    collection_info: {
      collection_site: "WOUND",
      specimen_type: "Wound Swab",
      collection_date: "2024-01-22T10:15:00-06:00",
      received_date: "2024-01-22T16:45:00-06:00"
    },
    provider_info: {
      provider_name: "Dr. Rachel Kim",
      provider_location: "Surgical Wound Care"
    },
    test_details: {
      bacteria: [
        { name: "Enterococcus faecium", result: "Detected" },
        { name: "Staphylococcus aureus", result: "Not Detected" }
      ],
      viruses: [],
      fungi: [],
      resistance_genes: [
        { name: "vanA", result: "Detected" },
        { name: "mecA", result: "Not Detected" }
      ]
    },
    analysis_results: {
      pathogens: {
        detected: {
          bacteria: [{ name: "Enterococcus faecium", result: "Detected" }],
          viruses: [],
          fungi: [],
          parasites: []
        }
      },
      weighted_pathogens: [
        {
          name: "Enterococcus faecium",
          standardized_name: "enterococcus faecium",
          category: "bacteria",
          weight: 55.1,
          priority_rank: 1
        }
      ],
      treatment: {
        primary: {
          drug_name: "Linezolid",
          dosage: "600 mg",
          route: "IV",
          frequency: "q12h"
        },
        drug_recommendations: {
          alternatives: [
            { name: "Daptomycin", dosage: "10 mg/kg", route: "IV", frequency: "q24h" },
            { name: "Tigecycline", dosage: "100 mg", route: "IV", frequency: "q12h" }
          ]
        },
        precautions: {
          monitoring_requirements: [
            "Monitor for VRE resistance",
            "Assess wound healing",
            "Monitor for drug interactions"
          ]
        }
      }
    }
  }
};

export const getReportData = (reportTypeId: string): ReportData | undefined => {
  return SAMPLE_REPORT_DATA[reportTypeId];
}; 